function performSearch() {
    const searchInput = document.getElementById('search-input-front');
    const searchText = searchInput.value.trim();
    if (searchText) {
        window.location.href = '/rattskalla/?query=' + encodeURIComponent(searchText);
    } else {
        window.location.href = '/rattskalla/'
    }
}
 
// Handle button click
document.getElementById('search-btn-front').addEventListener('click', performSearch);
 
// Handle Enter key press
document.getElementById('search-input-front').addEventListener('keypress', function(e) {
    if (e.key === 'Enter') {
        performSearch();
    }
});